import { Icon, MenuItem, useTheme } from '@web-chat-core/ui-kit';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { openModal } from 'useCase/modal/useModal';
import { ModalName } from 'features/Modals/ModalProvider';
import { isLocalUserModerator } from 'useCase/moderation/status/moderators';
import { isWebinarFeatureOn } from 'useCase/featureFlags/featureFlagsApi';

export const WebinarModeMenuItem = observer(() => {
    const theme = useTheme();
    const { t } = useTranslation();

    if (!isWebinarFeatureOn() || !isLocalUserModerator()) {
        return null;
    }

    return (
        <MenuItem id="webinar-mode-menu-item" onClick={() => openModal(ModalName.WEBINAR_MODE)}>
            <Icon icon="icSpeaker" color={theme.root.colors.basicColors['60%']} size={24} />
            {t('vks_webinar_mode_title')}
        </MenuItem>
    );
});
